import { type PropsWithChildren, Suspense } from "react";

import {
  V2Dialog as Dialog,
  V2DialogContent as DialogContent,
  V2DialogHeader as DialogHeader,
} from "@stacklet/ui";

import { DialogFallback } from "../fallbacks";

/** Props for the SuspenseDialog component */
interface Props extends PropsWithChildren {
  /** Whether the dialog is open */
  open: boolean;
  /** Callback to close the dialog */
  onClose: () => void;
  /** Dialog title */
  title: string;
  /** Whether clicking the backdrop or pressing Escape closes the dialog */
  isDismissable?: boolean;
}

export function SuspenseDialog({
  open,
  onClose,
  title,
  isDismissable = true,
  children,
}: Props) {
  return (
    <Dialog
      isDismissable={isDismissable}
      isOpen={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose();
      }}
      overlayClassName="z-[1300]"
    >
      <DialogHeader>{title}</DialogHeader>
      <DialogContent>
        <Suspense fallback={<DialogFallback />}>{children}</Suspense>
      </DialogContent>
    </Dialog>
  );
}
